import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { MenuController, NavController } from '@ionic/angular';
import { Store } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';

import { PageConstant, PagePath } from 'src/app/constants';
import { PosManagerBackToPos } from 'src/app/store/pos-manager';
import { AppSelectors } from 'src/app/store/app/app.selectors';
import { PosManagerService } from 'src/app/services';
import { NavigationItem } from 'src/app/pages/pos-manager/main/main.page';
import { ManagerMenuAbstractClass } from 'src/app/components/pos-manager/manager-menu-abstract';

@Component({
  selector: 'pos-manager-menu',
  templateUrl: './manager-menu.component.html',
  styleUrls: ['./manager-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManagerMenuComponent
  extends ManagerMenuAbstractClass
  implements OnInit, OnDestroy
{
  readonly pageConstant = PageConstant;
  readonly PagePath = PagePath;
  filterNavigationItems: Partial<NavigationItem>[] = [];

  constructor(
    private readonly menuController: MenuController,
    private readonly store: Store,
    private readonly navController: NavController,
    private readonly posManagerService: PosManagerService,
    private readonly route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    this.filterNavigationItems = this.initNavigationItems(
      this.store.selectSnapshot(AppSelectors.getOperator),
      this.posManagerService.canAccessReportingPage
    );
  }

  onGoTo(url: string) {
    this.navController.navigateRoot(url);
  }

  close() {
    this.menuController.close();
  }

  async backToPos() {
    await this.menuController.close();
    this.store.dispatch(new PosManagerBackToPos(this.route));
  }

  goToRealTime() {
    this.navController.navigateRoot(
      PageConstant.POS_MANAGER_POS_REAL_TIME_INFO_PAGE
    );
  }

  ngOnDestroy(): void {
    this.menuController
      .isOpen()
      .then((isOpen) => isOpen && this.menuController.close());
  }
}
